<template>
  <h3 class="separatorAuthor">
    Sentrale personar
  </h3>
</template>

<script>
export default {
  name: "SeparatorAuthor_nn",
};
</script>
